import { useTrackEvent } from "@/libs/analytics/useAnalytics";
import {
  createTokenTransferInitiatedTrackEventPayload,
  createMfaCodeRedeemedTrackEventPayload,
  createReceiverWalletAddressConfirmedTrackEventPayload,
  createTokenTransferPendingViewedPageEventPayload,
  createTokenTransferClickedTrackEventPayload,
  createTokenTransferFAQsClickedTrackEventPayload,
  createBeginTransferClickedTrackEventPayload,
  createTokenTransferConfirmationViewedPageEventPayload,
} from "nvs-analytics";
import { TokenTransferToken } from "../..";
import { MINT_CHAIN_ID } from "./constants";

export const useTokenTransferAnalytics = (
  token?: TokenTransferToken,
  collectionSlug?: string,
  swooshHandle?: string,
) => {
  const trackTokenTransferInitiated = useTokenTransferInitiatedAnalytics();
  const trackMfaCodeRedeemed = useMfaCodeRedeemedAnalytics();
  const trackReceiverWalletAddressConfirmed =
    useReceiverWalletAddressConfirmedAnalytics();
  const trackTokenTransferClicked = useTokenTransferClickedAnalytics();
  const tokenTransferFAQsClicked = useTokenTransFAQsClickedAnalytics();
  const trackBeginTransferClickedAnalytics = useBeginTransferClickedAnalytics();

  const trackTokenTransferPendingViewed =
    useTokenTransferPendingViewedAnalytics();
  const trackTokenTransferConfirmationViewed =
    useTokenTransferConfirmationViewedAnalytics();

  const payload = {
    collection: {
      chainId: MINT_CHAIN_ID,
      contractAddress: token?.contractAddress ?? "",
      slug: collectionSlug ?? "",
    },
    token: {
      id: token?.id ?? "",
      name: token?.name ?? "",
      ownerHandle: swooshHandle ?? "",
    },
  };

  const tokenTransferInitiated = () => {
    trackTokenTransferInitiated(payload);
  };
  const beginTransferClicked = () => {
    trackBeginTransferClickedAnalytics(payload);
  };
  const mfaCodeRedeemed = () => {
    trackMfaCodeRedeemed(payload);
  };
  const receiverWalletAddressConfirmed = () => {
    trackReceiverWalletAddressConfirmed(payload);
  };
  const tokenTransferClicked = () => {
    trackTokenTransferClicked(payload);
  };
  const tokenTransferPendingViewed = () => {
    trackTokenTransferPendingViewed(payload);
  };
  const tokenTransferConfirmationViewed = () => {
    trackTokenTransferConfirmationViewed(payload);
  };

  return {
    tokenTransferInitiated,
    beginTransferClicked,
    mfaCodeRedeemed,
    receiverWalletAddressConfirmed,
    tokenTransferClicked,
    tokenTransferPendingViewed,
    tokenTransferConfirmationViewed,
    tokenTransferFAQsClicked,
  };
};

export const useTokenTransferInitiatedAnalytics = () => {
  return useTrackEvent(createTokenTransferInitiatedTrackEventPayload);
};
export const useMfaCodeRedeemedAnalytics = () => {
  return useTrackEvent(createMfaCodeRedeemedTrackEventPayload);
};
export const useReceiverWalletAddressConfirmedAnalytics = () => {
  return useTrackEvent(createReceiverWalletAddressConfirmedTrackEventPayload);
};
export const useTokenTransferClickedAnalytics = () => {
  return useTrackEvent(createTokenTransferClickedTrackEventPayload);
};
export const useTokenTransFAQsClickedAnalytics = () => {
  return useTrackEvent(createTokenTransferFAQsClickedTrackEventPayload);
};
export const useBeginTransferClickedAnalytics = () => {
  return useTrackEvent(createBeginTransferClickedTrackEventPayload);
};
export const useTokenTransferPendingViewedAnalytics = () => {
  return useTrackEvent(createTokenTransferPendingViewedPageEventPayload);
};
export const useTokenTransferConfirmationViewedAnalytics = () => {
  return useTrackEvent(createTokenTransferConfirmationViewedPageEventPayload);
};
